module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/transport-3e3ca198092e71027a20f8e64f1e70b6.webp";